
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sprawdz-dostepnosc",
      function () {
        return require("private-next-pages/sprawdz-dostepnosc/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sprawdz-dostepnosc"])
      });
    }
  